import React, { PropTypes } from 'react';
import ExclusionBox from './ExclusionBox';

const exclusionId = (exclusion, answer, product) =>
  answer.id + '_' + product.id + '_' + exclusion.order;

export default class ScoreCell extends React.Component {
  static propTypes = {
    answer: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
    exclusions: PropTypes.array.isRequired,
    updateScore: PropTypes.func.isRequired,
    updateExclusion: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleScoreUpdate = this.handleScoreUpdate.bind(this);
  }

  handleScoreUpdate(e) {
    this.props.updateScore(
      this.props.product.id,
      this.props.answer.id,
      Number(e.target.value)
    );
  }

  render() {
    const { product, answer, exclusions } = this.props;

    const score = product.scores.find(s => s.answer === answer.id);
    const value = score ? score.score : 0;

    return (
      <div className="td" data-visible={exclusions.length}>
        <input type="number" value={value} onChange={this.handleScoreUpdate} />
        {exclusions.map(exclusion => (
          <ExclusionBox
            key={exclusionId(exclusion, answer, product)}
            exclusion={exclusion}
            product={product.id}
            answer={answer}
            onChange={this.props.updateExclusion}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/ScoreCell.js